import React from "react";
import image1 from "../../images/LudoBlue/Gemini_Generated_Image_r9b9k1r9b9k1r9b9.png";
import image2 from "../../images/LudoBlue/Gemini_Generated_Image_ldy1gyldy1gyldy1.png";

import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function ScrollToAnchor() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);
  return null;
}

const LudoBlue = () => {
  return (
    <div className="container my-5">
      <section >
        <ScrollToAnchor />
        <div class="row align-items-center">
          <div class="col-md-4">
            <img src={image1} alt="Description" class="img-fluid rounded"></img>
          </div>
          <div class="col-md-8">
              <div class="row justify-content-center">
                <div class="col-lg-12">
                  <div class="card shadow-lg border-0">
                    <div class="card-body p-5">
                      
                      <h2 class="card-title text-center mb-4" id="qui">Qui Sommes-Nous ?</h2>
                      <p class="card-text">
                        <strong>LudoBlue</strong> est née d'une passion commune : celle du jeu sous toutes ses formes. 
                        Fondée en 2023 par un collectif de joueurs, de parents et de professionnels de l'animation, 
                        notre association a pour mission de promouvoir le jeu comme vecteur de lien social, 
                        d'apprentissage et de développement personnel.
                      </p>
                    
                        <h4 class="mt-4 mb-3">Nos valeurs :</h4>

                      <ul class="list-group list-group-flush mb-4">
                        <li class="list-group-item">
                          <strong>Partage :</strong> Nous encourageons la rencontre et l'échange entre les générations 
                          et les cultures autour d'un plateau de jeu.
                        </li>
                        <li class="list-group-item">
                          <strong>Accessibilité :</strong> Nous nous efforçons de rendre le jeu accessible à tous, 
                          quels que soient l'âge, la situation sociale ou le handicap.
                        </li>
                        <li class="list-group-item">
                          <strong>Découverte :</strong> Notre catalogue est en constante évolution pour vous faire 
                          découvrir des pépites ludiques, des classiques indémodables aux dernières nouveautés.
                        </li>
                        <li class="list-group-item">
                          <strong>Jeu Libre :</strong> Nous défendons l'importance du jeu pour le plaisir, sans esprit 
                          de compétition systématique, pour le simple bonheur d'être ensemble.
                        </li>
                      </ul>

                    <p class="card-text">
                      Notre équipe de bénévoles et de ludothécaires passionnés est à votre disposition pour vous 
                      conseiller et vous guider dans cet univers infini. 
                    </p>
                    <p><strong>N'hésitez pas à venir nous rencontrer !</strong></p>

                </div>
              </div>
      </div>
  </div>

</div>
  </div>
      </section>

      <hr />

      <section >

        <div class="row align-items-center">
    <div class="col-md-8">
      <div class="row justify-content-center">        
    <div class="col-lg-12">
      <div class="card shadow-lg border-0">
        <div class="card-body p-5">
          <h2 class="card-title text-center mb-4" id="itinerance">LudoBlue se déplace pour vous !</h2>
           <p class="card-text">
            Le jeu doit être accessible partout et pour tous ! C'est pourquoi nous avons créé notre service de ludothèque itinérante. Avec notre "LudoVan" remplie de trésors, nous sillonnons les routes pour apporter la joie du jeu dans les communes, les quartiers, les écoles et les événements de la région.

          </p>

          <h4 class="mt-4 mb-3">Où nous trouver ?</h4>
            <p>Consultez notre calendrier en ligne pour connaître les prochaines dates et lieux de passage de notre ludothèque mobile. Nous nous installons sur les places de marché, dans les parcs, les salles des fêtes ou directement au sein de votre structure.</p>

          <h4 class="mt-5 mb-3">Nos services en itinérance :</h4>
          <ul class="list-group list-group-flush mb-4">
            <li class="list-group-item">
              <strong>Prêt de jeux :</strong> Accédez à une sélection de notre catalogue directement près de chez vous.
            </li>
            <li class="list-group-item">
              <strong>Animations sur site :</strong> Nous organisons des après-midis jeux en plein air ou en intérieur.
            </li>
            <li class="list-group-item">
              <strong>Partenariats :</strong> Nous collaborons avec les mairies, les écoles et les associations locales 
              pour créer des événements ludiques sur mesure.
            </li>
          </ul>
 <p class="card-text">
            Vous souhaitez que le <strong>LudoVan</strong> fasse une halte dans votre commune ou lors de votre événement ?
            
          </p>
        <p><strong>Contactez-nous</strong> pour discuter des possibilités !</p>
          
        </div>
      </div>
    </div>
  </div>
    </div>
    <div class="col-md-4">  <img src={image2} alt="Description" class="img-fluid rounded"></img></div>
  </div>
         
      </section>
    </div>
  );
};

export default LudoBlue;
